<template>
  <div id="edit-user" class="modal">
    <div class="modal-content animate">
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">{{'Chỉnh sửả tài khoản'}} </div>
          <p-button type="success" @click="sendData">Gửi chỉnh sửa</p-button>
          <span onclick="document.getElementById('edit-user').style.display='none';" class="close" title="Close Modal">&times;</span>
        </div>
        <div>
            <form class="form-horizontal">
              <h4 slot="header" class="card-title" style="margin-left:30px">
                Thông tin chỉnh sửa
              </h4>
              <div class="row">
                <!-- <label class="col-md-3 col-form-label">Tên tài khoản</label>
                <div class="col-md-9">
                  <fg-input placeholder="Tên tài khoản" v-model="username"></fg-input>
                </div>

                <label class="col-md-3 col-form-label">Thông tin</label>
                <div class="col-md-9">
                  <fg-input placeholder="Thông tin" v-model="info"></fg-input>
                </div>


                <label class="col-md-3 col-form-label">Mật khẩu</label>
                <div class="col-md-9">
                  <fg-input placeholder="Mật khẩu" v-model="password"></fg-input>
                </div> -->

                <label class="col-md-3 col-form-label">Các node được sử dụng</label>
                <div class="col-md-9">
                  <fg-input placeholder="Các node được sử dụng" v-model="nodes"></fg-input>
                </div>

                <div style="height:50px;width:100%">
                </div>
              </div>
            </form>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Card } from 'src/components/UIComponents';
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {Table, TableColumn, Select, Option, InputNumber} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import {Button} from 'src/components/UIComponents'
  import axios from "axios";
  import VueAxios from "vue-axios";

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      Card,
      PSwitch,
      PPagination,
      [Button.name]: Button
    },
    props:{
      username: String
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        nodes: '',
      }
    },
    methods: {
      sendData () {    
        const that = this;
        if (this.$data.nodes.trim() == '')  {
          alert('Bạn phải nhập đủ các thông tin');
        } else if (this.$data.nodes[this.$data.nodes.length - 1] != ';') {
          alert('Sai định dạng danh sách node : Thiếu ; ở cuối')
        } else if (this.$data.nodes.match(/[a-z]/i)) {
          alert('Sai định dạng danh sách node : Chuỗi điều khiển chỉ được chứa số ')
        } else {
          let tokenkey = localStorage.getItem('token');
          let data = {
            tokenkey: tokenkey,
            nodes: this.$data.nodes.trim(),
            username: that.username,
          }
          axios({url: '/Account/EditUser', 
                data: data, 
                method: 'POST' })
          .then(function(res){
            alert('Chỉnh sửa tài khoản thành công');
            location.reload();
            return(res)
          })
          .catch(function(err){
            alert("Chỉnh sửa tài khoản thất bại")
            location.reload();
            return(err)
          })
        }
      }      
    },
    async mounted() {
      
    }
  }
</script>
<style scoped>
.modal{
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 900px;
    height: 100%;
    min-height: 60px;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    padding-top: 60px;
}
.modal-content {
    background-color: #fefefe;
    margin: 3% 2% 0% auto; /* 0% from the top, 15% from the bottom and centered */
    border: 1px solid #888;
    width: 70%; /* Could be more or less, depending on screen size */
    height:auto;
    border-radius:5px;
}

.close {
    color: #000;
    font-size: 35px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: red;
    cursor: pointer;
}

/* Add Zoom Animation */
.animate {
    -webkit-animation: animatezoom 0.6s;
    animation: animatezoom 0.6s
}

.modal .el-table table tbody tr td{
  padding: 3px 0px;
}



@-webkit-keyframes animatezoom {
    from {-webkit-transform: scale(0)} 
    to {-webkit-transform: scale(1)}
}
  
@keyframes animatezoom {
    from {transform: scale(0)} 
    to {transform: scale(1)}
}
</style>
-